/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AddChatMessageTemplateInput = {
  body: string;
  label: string;
  selections: Array<string>;
};

export type SettingsPageAddChatMessageTemplateMutationVariables = Exact<{
  input: Types.AddChatMessageTemplateInput;
}>;


export type SettingsPageAddChatMessageTemplateMutation = { addChatMessageTemplate: Array<{ guid: string, label: string, body: string, selections: Array<string> }> };


export const SettingsPageAddChatMessageTemplateDocument = gql`
    mutation SettingsPageAddChatMessageTemplate($input: AddChatMessageTemplateInput!) {
  addChatMessageTemplate(input: $input) {
    guid
    label
    body
    selections
  }
}
    `;

/**
 * __useSettingsPageAddChatMessageTemplateMutation__
 *
 * To run a mutation, you first call `useSettingsPageAddChatMessageTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageAddChatMessageTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSettingsPageAddChatMessageTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSettingsPageAddChatMessageTemplateMutation(options: VueApolloComposable.UseMutationOptions<SettingsPageAddChatMessageTemplateMutation, SettingsPageAddChatMessageTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SettingsPageAddChatMessageTemplateMutation, SettingsPageAddChatMessageTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SettingsPageAddChatMessageTemplateMutation, SettingsPageAddChatMessageTemplateMutationVariables>(SettingsPageAddChatMessageTemplateDocument, options);
}
export type SettingsPageAddChatMessageTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SettingsPageAddChatMessageTemplateMutation, SettingsPageAddChatMessageTemplateMutationVariables>;